<template>
  <div>
    <slot :model="model">

    </slot>
  </div>
</template>

<script>
export default {
  props: {
    modelId: {
      type: Number,
      default: null
    },
    service: {
      type: Object,
      default: () => null
    }
  },

  data: () => ({
    model: null
  }),

  beforeMount() {
    if (this.service && this.modelId) {
      this.$vs.loading()
      this.service.read(this.modelId).then(
        response => {
          this.model = response
        },
        error => {
          this.notifyError("Erro ao buscar registro")
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    }
  }
}
</script>

<style>

</style>